/*
  The product page, royal (round 35): the little that moves on it. Loaded by sections/main-product.liquid.
  - the certificate: the house's wax seal is pressed on its corner as it comes into view (once);
  - the collection band (sections/product-story.liquid): its film plays over the page, made only when asked for and
    taken away when closed, so nothing of YouTube loads before a visitor asks; its drawn name is cropped to its ink,
    so every wordmark stands at one height whatever padding its file carries (as on Our Story).
  Visitors who ask for reduced motion see the seal already pressed.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- the seal, pressed on the certificate's corner as that corner comes into view ---- */
  function seals(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('[data-vr-cert]').forEach(function (cert) {
      if (cert.dataset.vrCertReady) return;
      cert.dataset.vrCertReady = '1';
      var seal = cert.querySelector('.vr-pdp__seal');
      if (!seal) return;
      cert.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          window.requestAnimationFrame(function () { cert.classList.add('is-pressed'); });
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -10% 0px' });
      io.observe(seal);
    });
  }

  /* ---- the collection band: its photograph opens out of the dark and its drawn name takes one band of light ---- */
  function bands(root) {
    root.querySelectorAll('[data-vr-band]').forEach(function (band) {
      if (band.dataset.vrLitReady) return;
      band.dataset.vrLitReady = '1';
      if (reduce || !('IntersectionObserver' in window)) { band.classList.add('is-lit'); return; }
      var r = band.getBoundingClientRect();
      /* not yet on the screen: the photograph waits in the dark */
      if (r.top > window.innerHeight * 0.9) band.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          window.requestAnimationFrame(function () { band.classList.add('is-lit'); });
        });
      }, { threshold: 0.35 });
      io.observe(band);
    });
  }

  /* ---- the film of the collection, over the page ---- */
  function films(root) {
    root.querySelectorAll('[data-vr-band]').forEach(function (band) {
      if (band.dataset.vrBandReady) return;
      band.dataset.vrBandReady = '1';
      var modal = band.querySelector('[data-vr-film-modal]');
      if (!modal) return;
      /* the player lives at the end of the page, above every other layer of the theme (one per section: the editor
         redraws a section with its player inside it, and the one moved out before is taken away) */
      Array.prototype.forEach.call(document.querySelectorAll('body > [data-vr-film-modal]'), function (m) { if (m.id === modal.id) m.parentNode.removeChild(m); });
      document.body.appendChild(modal);
      var frame = modal.querySelector('.vr-film-modal__frame');
      var title = modal.querySelector('.vr-film-modal__title');
      var close = modal.querySelector('[data-vr-film-close]');
      var from = null, timer = 0;
      var open = function (id, name, button) {
        if (!id) return;
        window.clearTimeout(timer);
        from = button;
        title.textContent = name || '';
        while (frame.firstChild) frame.removeChild(frame.firstChild);
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.title = name || 'Film';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        frame.appendChild(f);
        modal.hidden = false;
        document.documentElement.classList.add('vr-film-open');
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
        close.focus();
      };
      var shut = function () {
        if (modal.hidden) return;
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('vr-film-open');
        /* the player goes as the fade begins, so the sound stops at once */
        while (frame.firstChild) frame.removeChild(frame.firstChild);
        timer = window.setTimeout(function () { modal.hidden = true; }, reduce ? 0 : 500);
        if (from) from.focus();
      };
      band.querySelectorAll('[data-vr-film]').forEach(function (b) {
        b.addEventListener('click', function () { open(b.getAttribute('data-vr-film'), b.getAttribute('data-vr-film-title'), b); });
      });
      close.addEventListener('click', shut);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('vr-film-modal__inner')) shut(); });
      document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !modal.hidden) shut(); });
      /* the keyboard stays with the film while it is open */
      document.addEventListener('focusin', function (e) { if (!modal.hidden && modal.classList.contains('is-open') && !modal.contains(e.target)) close.focus(); });
    });
  }

  /* ---- the drawn names, cropped to their ink (as in assets/vr-story.js) ---- */
  function marks(root) {
    root.querySelectorAll('.vr-story-band__mark[data-vr-mark]').forEach(function (b) {
      if (b.dataset.vrMarkReady) return;
      b.dataset.vrMarkReady = '1';
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = 240, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var g = c.getContext('2d'); g.drawImage(im, 0, 0, W, H);
          var d = g.getImageData(0, 0, W, H).data;
          var x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
          if (x1 < 0) return;
          var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
          var ar = (fw * im.naturalWidth) / (fh * im.naturalHeight);
          var px = fw >= 0.999 ? 50 : fx / (1 - fw) * 100, py = fh >= 0.999 ? 50 : fy / (1 - fh) * 100;
          b.style.setProperty('--ink-ar', ar.toFixed(4));
          b.style.setProperty('--ink-boost', Math.min(1.42, Math.max(0.78, Math.sqrt(2.4 / ar))).toFixed(3));
          b.style.setProperty('--ink-size', (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%');
          b.style.setProperty('--ink-pos', px.toFixed(2) + '% ' + py.toFixed(2) + '%');
          b.classList.add('is-measured');
        } catch (e) { /* a file the canvas may not read: shown whole */ }
      };
      im.src = b.getAttribute('data-vr-mark');
    });
  }

  function init(root) {
    root = root || document;
    seals(root);
    bands(root);
    films(root);
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { marks(root); }, { timeout: 1500 });
    else window.setTimeout(function () { marks(root); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  /* the theme editor redraws a section in place */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
